import type { TranscriptHighlight, TextSegment } from '../types';

const PLAIN_SEGMENT: TextSegment = { text: '', highlightId: null, hasNote: false };

export default function buildTextSegments(
  displayText: string,
  highlights: TranscriptHighlight[],
): TextSegment[] {
  if (!highlights.length) {
    return [{ text: displayText, highlightId: null, hasNote: false }];
  }

  const len = displayText.length;
  const sorted = highlights
    .map((h) => ({
      ...h,
      startOffset: Math.max(0, Math.min(h.startOffset, len)),
      endOffset: Math.max(0, Math.min(h.endOffset, len)),
    }))
    .filter((h) => h.startOffset < h.endOffset)
    .sort((a, b) => a.startOffset - b.startOffset);

  if (!sorted.length) {
    return [{ text: displayText, highlightId: null, hasNote: false }];
  }

  const segments: TextSegment[] = [];
  let cursor = 0;

  for (const hl of sorted) {
    if (hl.startOffset > cursor) {
      segments.push({ text: displayText.slice(cursor, hl.startOffset), highlightId: null, hasNote: false });
    }
    segments.push({
      text: displayText.slice(hl.startOffset, hl.endOffset),
      highlightId: hl.highlightId,
      hasNote: hl.note.length > 0,
      hasTags: !!(hl.tags && hl.tags.length > 0),
      isLocalOnly: hl.isLocalOnly,
      isTeam: hl.visibility === 'team' && !hl.isLocalOnly,
      isRemote: hl.isRemote,
      showTeamBadge: hl.showTeamBadge !== false,
    });
    cursor = hl.endOffset;
  }

  if (cursor < len) {
    segments.push({ text: displayText.slice(cursor), highlightId: null, hasNote: false });
  }

  return segments;
}
